// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3zKQJ","inner":"Form_inner__SSnN2","range":"Form_range__2p1Rq","name":"Form_name__2piHf","actions":"Form_actions__3ekke"};